// Redux
import { Reducer } from 'redux';

// Models
import {
  CustomChecklistActionTypes,
  CustomChecklistState,
} from 'app/shared/customChecklist/models';

// Utils
import deepFreeze from 'app/shared/utils/deepFreeze';

// Helpers
import { getValidatedCustomChecklist } from 'app/shared/customChecklist/helpers';

// Actions
import { CustomChecklistActions } from 'app/shared/customChecklist/actions';

const initialState: Readonly<CustomChecklistState> = {
  content: {},
  checklistId: 0,
  definition: undefined,
  history: [],
};

// to ensure initialState is readonly
deepFreeze(initialState);

const reducer: Reducer<CustomChecklistState> = (
  state = initialState,
  action: CustomChecklistActions,
): CustomChecklistState => {
  if (
    action.type === CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST_SUCCESS
  ) {
    const { id, definition } = action.payload;
    return {
      content: {},
      checklistId: id,
      definition,
      history: [],
    };
  }

  if (
    action.type ===
    CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST_SUBMISSION_SUCCESS
  ) {
    const {
      content,
      custom_checklist: customChecklist,
      history,
    } = action.payload;

    return getValidatedCustomChecklist({
      content,
      checklistId: customChecklist.id,
      definition: customChecklist.definition,
      history,
    });
  }

  if (action.type === CustomChecklistActionTypes.UPDATE_CUSTOM_CHECKLIST_ITEM) {
    const { key, value } = action.payload;
    return {
      ...state,
      content: {
        ...state.content,
        [key]: value,
      },
    };
  }

  return state;
};

export { reducer as customChecklistReducer, initialState };
